import { useState } from "react";
import Icon from "../../Icon";
import { useOutsideClick } from "hooks/useOutsideClick";
import { LOGO_URL } from "utils/constants";
import { useSwitchClientsList } from "features/Client/useSwitchClientList";
import { useClientSwitcher } from "hooks/useClientSwitcher";
import styles from "./SubClientDropdown.module.css";

export default function SubClientDropdown({
  userLoginUrl,
  userName,
}: {
  userLoginUrl: string | null;
  userName: string;
}) {
  const { data: assignedSubClientsList = [] } = useSwitchClientsList();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useOutsideClick(() => setIsOpen(false));

  const { switchClient, buildSwitchUrl } = useClientSwitcher({
    userLoginUrl,
  });

  return (
    <div className={styles["switchuser_container"]} ref={ref}>
      <button
        onClick={() => setIsOpen((prev) => !prev)}
        style={{
          color: "var(--primary-color)",
          display: "flex",
          alignItems: "center",
          gap: "2px",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0
        }}
      >
        {userName}
        <Icon name="downArrow" iconAs="icon" color="currentColor" size={20} />
      </button>

      {isOpen && (
        <div className={styles["subclients_box"]}>
          <div className={styles["subclients_cards"]}>
            {assignedSubClientsList.map((subClient) => {
              let targetPath = "/dashboard";
              if (!subClient.isClient) {
                targetPath = "/account-management/accounts";
              }

              // stays on the current page by default
              const url = buildSwitchUrl(subClient, {
                targetPath,
              });

              return (
                <a
                  key={subClient.clientId}
                  href={url}
                  className={styles["subclient_info_card"]}
                  onClick={(e) => {
                    e.preventDefault();
                    switchClient(subClient, {
                      targetPath,
                    });
                  }}
                >
                  {subClient.needToShowClientLogo && (
                    <div className={styles["subclient_logo"]}>
                      <img
                        src={`${LOGO_URL}${subClient.clientLogoUrl}`}
                        alt={subClient.clientName}
                      />
                    </div>
                  )}

                  <div className={styles["subclient_name"]}>
                    <p>{subClient.clientName}</p>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}